var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h2',{staticClass:"text-center text-secondary my-5"},[_vm._v("Stub page for "+_vm._s(_vm.pageTitle))])
}
var staticRenderFns = []

export { render, staticRenderFns }